"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function useIsMounted() {
  var isMountedRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    isMountedRef.current = true;
    return function () {
      isMountedRef.current = false;
    };
  }, []);
  return (0, _react.useCallback)(function () {
    return isMountedRef.current;
  }, []);
}

var _default = useIsMounted;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy91c2VJc01vdW50ZWQudHMiXSwibmFtZXMiOlsidXNlSXNNb3VudGVkIiwiaXNNb3VudGVkUmVmIiwiY3VycmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBLFNBQVNBLFlBQVQsR0FBdUM7QUFDckMsTUFBTUMsWUFBWSxHQUFHLG1CQUFPLEtBQVAsQ0FBckI7QUFDQSx3QkFBVSxZQUFNO0FBQ2RBLElBQUFBLFlBQVksQ0FBQ0MsT0FBYixHQUF1QixJQUF2QjtBQUNBLFdBQU8sWUFBTTtBQUNYRCxNQUFBQSxZQUFZLENBQUNDLE9BQWIsR0FBdUIsS0FBdkI7QUFDRCxLQUZEO0FBR0QsR0FMRCxFQUtHLEVBTEg7QUFNQSxTQUFPLHdCQUFZO0FBQUEsV0FBTUQsWUFBWSxDQUFDQyxPQUFuQjtBQUFBLEdBQVosRUFBd0MsRUFBeEMsQ0FBUDtBQUNEOztlQUVjRixZIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ2FsbGJhY2ssIHVzZUVmZmVjdCwgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuXG5mdW5jdGlvbiB1c2VJc01vdW50ZWQoKTogKCkgPT4gYm9vbGVhbiB7XG4gIGNvbnN0IGlzTW91bnRlZFJlZiA9IHVzZVJlZihmYWxzZSk7XG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgaXNNb3VudGVkUmVmLmN1cnJlbnQgPSB0cnVlO1xuICAgIHJldHVybiAoKSA9PiB7XG4gICAgICBpc01vdW50ZWRSZWYuY3VycmVudCA9IGZhbHNlO1xuICAgIH07XG4gIH0sIFtdKTtcbiAgcmV0dXJuIHVzZUNhbGxiYWNrKCgpID0+IGlzTW91bnRlZFJlZi5jdXJyZW50LCBbXSk7XG59XG5cbmV4cG9ydCBkZWZhdWx0IHVzZUlzTW91bnRlZDtcbiJdfQ==